import React from 'react'

import { Box, Divider } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AccountCreationModal from 'modules/expenses/components/common/AccountCreationModal'
import CardsHero, { CardsImage, CtaDescription } from 'modules/expenses/components/common/CardsHero'
import StepsSection from 'modules/expenses/components/common/CardsLandingPage/Content/StepsSection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import FaqBlock from '../components/InitialSetup/FaqBlock'
import InfoPointsBlock from '../components/InitialSetup/InfoPointsBlock'

const AccountSetupPage = () => {
  const [isAccountCreationModalOpen, setIsAccountCreationModalOpen] = React.useState(false)
  const ctaDescription = CtaDescription.CREATE_ACCOUNT

  const onGetCards = () => {
    track(trackingEvents.softwareManagement.clickOnCardOnboardingButton, {
      status: ctaDescription,
    })
    setIsAccountCreationModalOpen(true)
  }

  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <Box justifyContent="center" alignItems="center">
        <CardsHero
          primaryButtonText={i18n.t('expenses_v2.cards.blocks.require_onboarding.get_my_cards_now')}
          ctaDescription={ctaDescription}
          cardsImage={CardsImage.SINGLE}
          isDismissable={false}
          onPrimaryButtonClick={onGetCards}
        />
        <Divider />
        <StepsSection isSoftwareSection onGetCardsClick={onGetCards} />
        <InfoPointsBlock onClickCta={onGetCards} />
        <FaqBlock />
        {isAccountCreationModalOpen && (
          <AccountCreationModal
            source="software"
            trackingEvent={undefined}
            onClose={() => {
              setIsAccountCreationModalOpen(false)
            }}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}
export default AccountSetupPage
